module.exports = __webpack_public_path__ + "static/media/doeLogo.e4861c50.png";